var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedaHousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2999 5.75416C21.2999 5.65281 21.2593 5.5137 21.1441 5.45805C20.236 5.02681 19.3076 4.61146 18.3589 4.17822V23.0677H21.3067C21.3067 22.9544 21.3067 22.859 21.3067 22.7636C21.3067 20.6253 21.3067 18.4869 21.3067 16.3485C21.3067 12.8171 21.3067 9.28563 21.2965 5.75416H21.2999Z",
    fill: "url(#paint0_radial_343_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03516 2.10154C8.03854 8.99555 8.03516 15.8915 8.03516 22.7855C8.03516 22.8789 8.03516 22.9723 8.03516 23.0757H10.0986V0.938965C9.48196 1.21719 8.92967 1.47753 8.35705 1.72197C8.12664 1.82133 8.03516 1.92865 8.03516 2.10154Z",
    fill: "url(#paint1_radial_343_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00412 10.2554C0.72628 10.3707 0.638184 10.4979 0.638184 10.6927C0.648349 14.7269 0.64496 18.7631 0.64496 22.7974V23.0637C0.780493 23.0736 0.871977 23.0836 0.963461 23.0836C1.8207 23.0836 2.67794 23.0836 3.5589 23.0836V9.14453C3.41998 9.1962 3.31495 9.22999 3.22007 9.27172C2.48142 9.59963 1.75294 9.93747 0.997344 10.2554H1.00412Z",
    fill: "url(#paint2_radial_343_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7368 5.35492C15.7402 11.1599 15.7368 16.9628 15.7368 22.7678C15.7368 22.8672 15.7368 22.9685 15.7368 23.0758H17.8714V4.1665C17.2209 4.4646 16.6279 4.7468 16.0112 5.0131C15.7978 5.1065 15.7334 5.20587 15.7334 5.35492H15.7368Z",
    fill: "url(#paint3_radial_343_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70694 10.2021C6.04283 9.88215 5.35162 9.58207 4.66718 9.27801C4.58925 9.24224 4.50115 9.21441 4.40967 9.18262V23.0759H6.96445C6.97123 22.9845 6.98139 22.9209 6.98139 22.8573C6.98139 18.7436 6.98478 14.6299 6.97462 10.5161C6.97462 10.4108 6.84925 10.2717 6.70694 10.2041V10.2021Z",
    fill: "url(#paint4_radial_343_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4726 2.21888C14.127 2.04003 13.7408 1.89098 13.3003 1.7002V23.0698H14.6048V22.7896C14.6048 18.187 14.6048 13.5843 14.6048 8.98172C14.6048 6.81952 14.6082 4.65931 14.6048 2.4991C14.6048 2.40371 14.5777 2.27254 14.4726 2.21888Z",
    fill: "url(#paint5_radial_343_54)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_343_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.14101 14.1859 -6.04225 7.06154 18.7465 6.76204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_343_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.4987 16.6246 -4.22957 8.27549 8.3065 3.96696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_343_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.12132 10.4682 -5.98669 5.2109 1.02225 11.0512)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_343_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.55284 14.2008 -4.38236 7.06897 16.0145 6.75304)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_343_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.86824 10.4338 -5.27245 5.19382 4.74792 11.083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_343_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.948552 16.0485 -2.67696 7.98872 13.472 4.62326)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6721,
    height: 22.1486,
    fill: "white",
    transform: "translate(0.638184 0.938965)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedaHousing);
export default __webpack_public_path__ + "static/media/Beda Housing.18eecce69b1e1768c1d54672e5d0a65a.svg";
export { ForwardRef as ReactComponent };